import React, { Component } from "react";

import { Badge } from "react-bootstrap";

class CommonRowId extends Component {
    render() {
        const { rowId } = this.props; 

        return (
            <> {rowId}</>
        );
    }
}

export default CommonRowId;
